import { useState } from 'react'
import { UiState } from '../managers/UIManager'
import { getEnabledClients, ClientConfig } from '../config/clients'
import ExperienceDetail from '../components/ExperienceDetail'
import { useEffect } from 'react'

interface Props {
  state: UiState
  setTab: (tab: UiState['activeTab']) => void
}

const CAROUSEL_IMAGES = [
  { src: '/images/carousel1.png' },
  { src: '/images/carousel2.png'},
  { src: '/images/carousel3.png'},
];

export default function HomeScreen({ state, setTab }: Props) {
  const clients = getEnabledClients().filter(c =>
    ['aana', 'freedom-fighters', 'pioneers', 'roq', 'rockardemo'].includes(c.clientId)
  )
  const featured = clients.find(c => c.clientId === 'aana') || clients[0]
  const recentEffects = clients.filter(c => c !== featured)

  const [detailClient, setDetailClient] = useState<ClientConfig | null>(null)

  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % CAROUSEL_IMAGES.length);
    }, 4000); // changes image every 4000ms 

    return () => clearInterval(timer); 
  }, []);

  // ensuring pressing home on the navbar resets the state
  useEffect(() => {
    if (state.activeTab === 'home') {
      setDetailClient(null);
    }
  }, [state.activeTab, state.tabTapKey]);

  return (
    <div className="app-screen home-screen">
      {/* Header */}
      <div className="app-screen-header">
        <span className="app-screen-title">Home</span>
    
        <div className="app-header-actions">
        {/* where search bar + notifications will be if*/}
        </div>
      </div>

      <div className="app-screen-scroll">
        {/* Logo strip */}
        <div className="home-logo-row">
          <img src="/rockarlogo.png" alt="ROCK AR" className="home-logo" />
        </div>

        {/* Hero video 
        <div className="home-section">
          <div className="home-video-card">
            <div className="home-featured-img-wrap">
              <img
                src="/video-placeholder.png"
                alt="Featured Video"
                className="home-featured-img"
              />

              <div className="home-featured-gradient" />

              <div className="home-featured-play">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="white"
                >
                  <polygon points="5 3 19 12 5 21 5 3" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      */}

        <div className="home-section">
          <div className="home-video-card" style={{ overflow: 'hidden', position: 'relative' }}>
            <div 
              className="home-carousel-track" 
              style={{ 
                display: 'flex', 
                transition: 'transform 0.5s ease-in-out', 
                transform: `translateX(-${currentImageIndex * (100 / CAROUSEL_IMAGES.length)}%)`, 
                width: `${CAROUSEL_IMAGES.length * 100}%` 
              }}
            >              
            {CAROUSEL_IMAGES.map((img, index) => (
                <div key={index} style={{ width: `${100 / CAROUSEL_IMAGES.length}%`, position: 'relative' }}>
                  <img
                    src={img.src}
                    className="home-carousel-img"
                    style={{ width: '100%', height: '100%', display: 'block', objectFit: 'cover' }}
                  />
                </div>
              ))}
            </div>

            <div style={{ position: 'absolute', bottom: '12px', left: '50%', transform: 'translateX(-50%)', display: 'flex', gap: '6px', zIndex: 2 }}>
              {CAROUSEL_IMAGES.map((_, index) => (
                <div
                  key={index}
                  style={{
                    width: '6px',
                    height: '6px',
                    borderRadius: '50%',
                    backgroundColor: currentImageIndex === index ? '#FDC700' : 'rgba(255,255,255,0.4)',
                    transition: 'background-color 0.3s'
                  }}
                />
              ))}
            </div>
          </div>
        </div>


      <div className="home-section">
        <span style={{ fontSize: "12px", color: "#FDC700", fontWeight: 500 }}>
          FEATURED
        </span>        
      <div className="home-section-header">
          <h2 className="home-section-title">AR Experiences</h2>
          <button className="home-see-all" onClick={() => setTab('explore')}>
            See All ›
          </button>
        </div>
      </div>

      {featured && (
  <button
    className="home-featured-card"
    onClick={() => setDetailClient(featured)}
  >
    <div className="home-featured-img-wrap">
     {/*
     } <img
        src={(featured as any).experienceItem?.thumbnail || '/rockarlogo.png'}
        alt={featured.clientName}
        className="home-featured-img"
      />
      */}
        <img
          src="/aana-featured-img.jpg"
          alt={featured.clientName}
          className="home-featured-img"
        />
      <div className="home-featured-gradient" />

      <span className="home-featured-badge">
        Featured
      </span>

      <div className="home-featured-overlay">
        <span className="home-collab-label">
          For CRNAs and nurse anesthesiologists
        </span>

        <h3 className="home-featured-title">
          {(featured as any).experienceItem?.title || featured.clientName}
        </h3>
      </div>
    </div>

    <div className="home-featured-stats">
       <span className="home-stat">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M12.32 19.98C11.74 19.98 11.16 19.76 10.72 19.32L4.24 12.85C4.1 12.71 4.02 12.52 4.02 12.32V4.77002C4.02 4.36002 4.36 4.02002 4.77 4.02002H12.31C12.51 4.02002 12.7 4.10002 12.84 4.24002L19.32 10.72C20.19 11.6 20.19 13.03 19.32 13.91L13.91 19.32C13.47 19.76 12.89 19.98 12.31 19.98H12.32ZM5.52 12.01L11.78 18.26C12.08 18.55 12.56 18.55 12.85 18.26L18.26 12.85C18.55 12.56 18.55 12.08 18.26 11.78L12 5.52002H5.52V12V12.01ZM8.5 9.75002C7.81 9.75002 7.25 9.19002 7.25 8.50002C7.25 7.81002 7.81 7.25002 8.5 7.25002C9.19 7.25002 9.75 7.81002 9.75 8.50002C9.75 9.19002 9.19 9.75002 8.5 9.75002Z"
          fill="white"> </path> 
        </svg>
        3 pins
      </span>

      {/* like button + comment button stats 
      <span className="home-stat">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="white" stroke="none">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
        </svg>
        88
      </span>

      <span className="home-stat">
        <svg
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="white"
          strokeWidth="2"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        24
      </span>
      */}

      {/* span instead of button — parent card is already a <button>, nesting is invalid HTML */}
      <span className="home-view-btn" aria-hidden="true">View ›</span>
    </div>
  </button>
)}

        {/* Recent Effects */}
        <div className="home-section">
          <div className="home-section-header">
            <h2 className="home-section-title">Recent Effects</h2>
            <button className="home-see-all" onClick={() => setTab('explore')}>See All ›</button>
          </div>

          <div className="home-effects-list">
            {recentEffects.map((client) => (
              <button
                key={client.clientId}
                className="home-effect-item"
                onClick={() => setDetailClient(client)}
              >
                <div className="home-effect-thumb">
                  <img
                    src={(client as any).experienceItem?.thumbnail || '/rockarlogo.png'}
                    alt={client.clientName}
                    className="home-effect-img"
                  />
                </div>
                <div className="home-effect-info">
                  <p className="home-effect-title">
                    {(client as any).experienceItem?.title || client.clientName}
                  </p>
                 <p className="home-effect-subtitle">
                    {(client as any).experienceItem?.subtitle || ''}
              </p>
                  {/* commented out statistics for now. 
                  <div className="home-effect-stats">
                    <span className="home-stat small">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="#E91E8C" stroke="none">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
                      </svg>
                      {Math.floor(Math.random() * 3000 + 500).toLocaleString()}
                    </span>
                    <span className="home-stat small">
                      <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.45)" strokeWidth="2">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                      </svg>
                      {Math.floor(Math.random() * 200 + 50)}
                    </span>
                  </div>
                  */}
                </div>
                <svg className="home-effect-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </button>
            ))}
          </div>
        </div>
      </div>

      {detailClient && (
        <ExperienceDetail
          client={detailClient}
          onClose={() => setDetailClient(null)}
          onScan={() => { setDetailClient(null); setTab('scan') }}
        />
      )}
    </div>
  )
}
